module.exports = __webpack_public_path__ + "static/vector-2-782b41d1cde3200cd9f3ef4bcf373160.svg";